<template>
  <div class="container">
    <div v-if="is_ok" class="row">
      <div class="col text-center">
        <h2>DATOS ENVIADOS</h2>
        <h3>Puede cerrar esta ventana</h3>
      </div>
    </div>
    <b-form v-else class="customer-fill-data" @submit="onSubmit" autocomplete="off">
      <div class="row form-group">
        <div class="col-sm-12">
          <h2>DATOS PERSONALES</h2>
        </div>


        <div v-if="!is_core" class="col-sm-7">
          <label for="edit_customer_name" class="wabident-info">
            Nombre y apellidos (Obligatorio)
          </label>
          <input v-model="form.name" type="text" class="form-control" name="name" id="edit_customer_name" required
            autocomplete="off" />
        </div>
        <div v-else class="col-sm-2">
          <label for="edit_customer_name" class="wabident-info">
            Nombre
          </label>
          <input v-model="form.name" type="text" class="form-control" name="name" id="edit_customer_name" required
            autocomplete="off" />
        </div>

        <div v-if="is_core" class="col-sm-5">
          <label for="edit_customer_surname" class="wabident-info">
            Apellidos
          </label>
          <input v-model="form.surname" type="text" class="form-control" name="surname" id="edit_customer_surname"
            required autocomplete="off" />
        </div>

        <div class="col-sm-2">
          <label for="customer_edit_sex" class="wabident-info">Sexo (Obligatorio)</label>
          <select v-model="form.sex" name="sex" id="customer_edit_sex" class="form-control custom-select"
            autocomplete="off">
            <option value="">Elige...</option>
            <option value="male">Hombre</option>
            <option value="female">Mujer</option>
            <option value="other">Otro</option>
          </select>
        </div>

        <div class="col-sm-3">
          <label for="customer_edit_birth_date" class="wabident-info">Fecha de nacimiento (Obligatoria)
          </label>

          <input v-model="form.birth_date" type="date" name="birth_date" id="customer_edit_birth_date"
            class="form-control" required autocomplete="off" />
        </div>
      </div>

      <div class="row form-group">
        <div class="col-sm-3">
          <label for="customer_edit_nif" class="wabident-info">DNI / Pasaporte (Obligatorio para Facturas)</label>
          <input v-model="form.nif" type="text" name="nif" id="customer_edit_nif" class="form-control"
            autocomplete="off" />
        </div>

        <div class="col-sm-3">
          <label for="customer_edit_phone" class="wabident-info">Teléfono (Obligatorio)
          </label>

          <input v-model="form.phone" type="tel" name="phone" id="customer_edit_phone" class="form-control" required
            autocomplete="off" />
        </div>
        <div class="col-sm-3">
          <label for="customer_edit_phone_alt" class="wabident-info">Teléfono secundario (Opcional)</label>
          <input v-model="form.phone_alt" type="tel" name="phone_alt" id="customer_edit_phone_alt" class="form-control"
            autocomplete="off" />
        </div>
        <div class="col-sm-3">
          <label for="customer_edit_email" class="wabident-info">Email</label>
          <input v-model="form.email" type="email" name="email" id="customer_edit_email" class="form-control"
            autocomplete="off" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-12">
          <legend>DIRECCIÓN</legend>
        </div>
        <div class="col-sm-6">
          <label for="customer_edit_address" class="wabident-info">Dirección</label>
          <input v-model="form.address" type="text" name="address" id="customer_edit_address" class="form-control"
            autocomplete="off" />
        </div>
        <div class="col-sm-3">
          <label for="customer_edit_city" class="wabident-info">Población</label>
          <input v-model="form.city" type="text" name="city" id="customer_edit_city" class="form-control"
            autocomplete="off" />
        </div>
        <div class="col-sm-3">
          <label for="customer_edit_zipcode" class="wabident-info">Código postal</label>
          <input v-model="form.zipcode" type="text" name="zipcode" id="customer_edit_zipcode" class="form-control"
            autocomplete="off" />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-sm-2">
          <legend>OTROS DATOS</legend>
        </div>
        <div class="col-sm-12">
          <label for="customer_edit_reason" class="wabident-info">¿Cómo nos conociste? (Obligatorio)</label>
          <select v-model="form.reason" name="reason" id="customer_edit_reason" class="form-control custom-select"
            autocomplete="off">
            <option value="">Elige una opción ...</option>
            <option v-for="(name, value) in customer_reasons" :value="value" :key="value">
              {{ name }}
            </option>
          </select>
        </div>
        <div class="col-sm-12">
          <label for="customer_edit_reference" class="wabident-info">Si nos conociste por referencia. ¿Recuerdas quien
            fue?</label>
          <input v-model="form.reference" type="text" name="reference" id="customer_edit_reference"
            placeholder="Nombre, perfil de Instagram, página web, etc ..." class="form-control" autocomplete="off" />
        </div>
      </div>

      <template v-if="show_history">
        <div class="row form-group mt-2">
          <div class="col">
            <h2>HISTORIA CLÍNICA</h2>
          </div>
        </div>

        <div class="form-group row">
          <div class="col customer-edit-history-section">
            <legend>Alergias</legend>
            <div class="customer-edit-history-checks">
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.allergies['medicines']" class="form-check-input" type="checkbox"
                  id="customer_edit_history_medicine_allergies" autocomplete="off" />
                <label for="customer_edit_history_medicine_allergies" class="form-check-label">
                  ¿Tiene alergias a algún medicamento?
                </label>
              </div>
            </div>
            <transition name="fade">
              <div v-if="history.allergies['medicines']">
                <legend>Indique cuales:</legend>
                <input type="text" class="form-control" v-model="history.allergies['other_medicines']"
                  autocomplete="off" />
              </div>
            </transition>
            <!-- SUBSTANCE ALLERGIES -->
            <div class="customer-edit-history-checks">
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.allergies['substances']" class="form-check-input" type="checkbox"
                  id="customer_edit_history_substance_allergies" autocomplete="off" />
                <label for="customer_edit_history_substance_allergies" class="form-check-label">
                  ¿Tiene alergias a alguna sustancia?
                </label>
              </div>
            </div>
            <transition name="fade">
              <div v-if="history.allergies['substances']">
                <legend>Indique cuales:</legend>
                <input type="text" class="form-control" v-model="history.allergies['other_substances']"
                  autocomplete="off" />
              </div>
            </transition>
          </div>
        </div>
        <!-- DISEASES CUSTOM -->
        <div class="row">
          <div class="col customer-edit-history-section">
            <legend>Enfermedades</legend>
            <div class="customer-edit-history-checks">
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.diseases['diabetes']" class="form-check-input" type="checkbox"
                  name="diseases[diabetes]" id="customer_edit_history_diabetes" autocomplete="off" />
                <label for="customer_edit_history_diabetes" class="form-check-label">
                  Diabetes
                </label>
              </div>
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.diseases['hypertension']" class="form-check-input" type="checkbox"
                  name="diseases[hypertension]" id="customer_edit_history_hypertension" autocomplete="off" />
                <label for="customer_edit_history_hypertension" class="form-check-label">
                  Hipertensión
                </label>
              </div>
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.diseases['autoinmune']" class="form-check-input" type="checkbox"
                  name="diseases[autoinmune]" id="customer_edit_history_autoinmune" autocomplete="off" />
                <label for="customer_edit_history_autoinmune" class="form-check-label">
                  Enf. Autoinmune
                </label>
              </div>
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.diseases['herpes']" class="form-check-input" type="checkbox"
                  name="diseases[herpes]" id="customer_edit_history_herpes" autocomplete="off" />
                <label for="customer_edit_history_herpes" class="form-check-label">
                  Herpes simple
                </label>
              </div>
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.diseases['other_diseases']" class="form-check-input" type="checkbox"
                  name="diseases[other_diseases]" id="customer_edit_history_other_diseases" autocomplete="off" />
                <label for="customer_edit_history_other_diseases" class="form-check-label">
                  ¿Tiene otras enfermedades
                  cardíacas/hepáticas/digestivas/óseas?
                </label>
              </div>
            </div>
            <transition name="fade">
              <div v-if="history.diseases['other_diseases']">
                <legend>Indique cuales:</legend>
                <input type="text" class="form-control" v-model="history.diseases['other_diseases_content']"
                  autocomplete="off" />
              </div>
            </transition>
          </div>
        </div>

        <!-- MEDICINES  -->
        <div class="row">
          <div class="col customer-edit-history-section">
            <legend>Medicación</legend>
            <div class="customer-edit-history-checks">
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.medicines['other_medicines']" class="form-check-input" type="checkbox"
                  id="customer_edit_history_other_medicines" autocomplete="off" />
                <label for="customer_edit_history_other_medicines" class="form-check-label">
                  ¿Toma algún tipo de medicación?
                </label>
              </div>
            </div>
            <transition name="fade">
              <div v-if="history.medicines['other_medicines']">
                <legend>Indique cuales:</legend>
                <input type="text" class="form-control" v-model="history.medicines['other_medicines_content']"
                  autocomplete="off" />
              </div>
            </transition>
          </div>
        </div>

        <!-- MEDICAL INTERVENTIONS -->
        <div class="row">
          <div class="col customer-edit-history-section">
            <legend>Intervenciones quirúrgicas</legend>
            <div class="customer-edit-history-checks">
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.background['surgical_interventions']" class="form-check-input" type="checkbox"
                  id="customer_edit_history_surgical_interventions" autocomplete="off" />
                <label for="customer_edit_history_surgical_interventions" class="form-check-label">
                  ¿Se ha realizado algún tipo de intervención quirúrgica?
                </label>
              </div>
            </div>
            <transition name="fade">
              <div v-if="history.background['surgical_interventions']">
                <legend>Indique cuales:</legend>
                <input type="text" class="form-control" v-model="history.background['surgical_interventions_content']"
                  autocomplete="off" />
              </div>
            </transition>
          </div>
        </div>

        <!-- MEDICAL INTERVENTIONS -->
        <div class="row">
          <div class="col customer-edit-history-section">
            <legend>Tratamientos estéticos previos</legend>
            <div class="customer-edit-history-checks">
              <div class="form-check form-check-inline form-check-history">
                <input v-model="history.background['previous_treatments']" class="form-check-input" type="checkbox"
                  id="customer_edit_history_previous_treatments" autocomplete="off" />
                <label for="customer_edit_history_previous_treatments" class="form-check-label">
                  ¿Se ha realizado algún tratamiento estético en otra clínica?
                </label>
              </div>
            </div>
            <transition name="fade">
              <div v-if="history.background['previous_treatments']">
                <legend>Indique cuales:</legend>
                <input type="text" class="form-control" v-model="history.background['previous_treatments_content']"
                  autocomplete="off" />
              </div>
            </transition>
          </div>
        </div>
      </template>


      <div v-if="is_core" class="form-group row">
        <!-- Alergias Core -->
        <div class="col customer-edit-history-section">
          <legend>¿Tiene alergia a alguna de estas sustancias?</legend>
          <!-- Latex -->
          <div class="form-check form-check-inline">
            <input v-model="history.allergies['latex']" class="form-check-input" type="checkbox"
              id="customer_edit_history_allergies_latex" autocomplete="off" />
            <label for="customer_edit_history_allergies_latex" class="form-check-label">
              Látex
            </label>
          </div>
          <!-- Penicilina -->
          <div class="form-check form-check-inline">
            <input v-model="history.allergies['penicillin']" class="form-check-input" type="checkbox"
              id="customer_edit_history_allergies_penicillin" autocomplete="off" />
            <label for="customer_edit_history_allergies_penicillin" class="form-check-label">
              Penicilina
            </label>
          </div>
          <!-- Custom Checks -->
          <div v-for="(label, slug) in custom_check_allergies" :key="slug" class="form-check form-check-inline">
            <input v-model="history.allergies[slug]" class="form-check-input" type="checkbox"
              :id="`customer_edit_history_allergies_${slug}`" autocomplete="off" />
            <label :for="`customer_edit_history_allergies_${slug}`" class="form-check-label">
              {{ label }}
            </label>
          </div>
          <!-- Otras -->
          <h6 class="mt-2">Otras alergias</h6>
          <textarea class="form-control" v-model="custom_core_allergies" rows="5" autocomplete="off"
            placeholder="Indique todas las alergias adicionales que tenga, una por línea"></textarea>
        </div>
      </div>

      <div v-if="is_core" class="form-group row">
        <div class="col customer-edit-history-section">
          <legend>¿Padece alguna de estas enfermedades?</legend>

          <div class="form-check form-check-inline">
            <input v-model="history.diseases['hepatitis']" class="form-check-input" type="checkbox"
              id="customer_edit_history_diseases_hepatitis" autocomplete="off" />
            <label for="customer_edit_history_diseases_hepatitis" class="form-check-label">
              Hepatitis
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.diseases['hiv']" class="form-check-input" type="checkbox"
              id="customer_edit_history_diseases_hiv" autocomplete="off" />
            <label for="customer_edit_history_diseases_hiv" class="form-check-label">
              VIH
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.diseases['diabetes']" class="form-check-input" type="checkbox"
              id="customer_edit_history_diseases_diabetes" autocomplete="off" />
            <label for="customer_edit_history_diseases_diabetes" class="form-check-label">
              Diabetes
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.diseases['heart_condition']" class="form-check-input" type="checkbox"
              id="customer_edit_history_diseases_heart_condition" autocomplete="off" />
            <label for="customer_edit_history_diseases_heart_condition" class="form-check-label">
              Problemas cardíacos
            </label>
          </div>

          <!-- Custom Checks -->
          <div v-for="(label, slug) in custom_check_diseases" :key="slug" class="form-check form-check-inline">
            <input v-model="history.diseases[slug]" class="form-check-input" type="checkbox"
              :id="`customer_edit_history_diseases_${slug}`" autocomplete="off" />
            <label :for="`customer_edit_history_diseases_${slug}`" class="form-check-label">
              {{ label }}
            </label>
          </div>

          <h6 class="mt-2">Otras enfermedades</h6>
          <textarea class="form-control" v-model="custom_core_diseases" rows="5"
            placeholder="Indique el resto de enfermedades, una por línea" autocomplete="off"></textarea>
        </div>
      </div>


      <div v-if="is_core" class="form-group row">
        <div class="col customer-edit-history-section">
          <legend>¿Toma alguno de estos medicamentos de forma regular?</legend>

          <div class="form-check form-check-inline">
            <input v-model="history.medicines['anticoagulants']" class="form-check-input" type="checkbox"
              id="customer_edit_history_medicines_anticoagulants" autocomplete="off" />
            <label for="customer_edit_history_medicines_anticoagulants" class="form-check-label">
              Anticoagulantes (Sintrom, Heparina, Clavix, etc ...)
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.medicines['inmunosuppressants']" class="form-check-input" type="checkbox"
              id="customer_edit_history_medicines_inmunosuppressants" autocomplete="off" />
            <label for="customer_edit_history_medicines_inmunosuppressants" class="form-check-label">
              Inmunosupresores
            </label>
          </div>

          <!-- Custom Checks -->
          <div v-for="(label, slug) in custom_check_medicines" :key="slug" class="form-check form-check-inline">
            <input v-model="history.medicines[slug]" class="form-check-input" type="checkbox"
              :id="`customer_edit_history_medicines_${slug}`" autocomplete="off" />
            <label :for="`customer_edit_history_medicines_${slug}`" class="form-check-label">
              {{ label }}
            </label>
          </div>

          <h6 class="mt-2">Otras medicamentos</h6>
          <textarea class="form-control" autocomplete="off" v-model="custom_core_medicines" rows="5"
            placeholder="Indique el resto de medicamentos, uno por línea"></textarea>
        </div>
      </div>


      <div v-if="is_core" class="form-group row">
        <div class="col customer-edit-history-section">
          <legend>¿Padece o ha padecido estas afecciones?</legend>

          <div class="form-check form-check-inline">
            <input v-model="history.background['headache']" class="form-check-input" type="checkbox"
              id="customer_edit_history_background_headache" autocomplete="off" />
            <label for="customer_edit_history_background_headache" class="form-check-label">
              Dolores de cabeza o migrañas
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.background['bruxism']" class="form-check-input" type="checkbox"
              id="customer_edit_history_background_bruxism" autocomplete="off" />
            <label for="customer_edit_history_background_bruxism" class="form-check-label">
              Bruxismo
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.background['neuralgia']" class="form-check-input" type="checkbox"
              id="customer_edit_history_background_neuralgia" autocomplete="off" />
            <label for="customer_edit_history_background_neuralgia" class="form-check-label">
              Neuralgia/Fibromialgia
            </label>
          </div>

          <!-- Custom Checks -->
          <div v-for="(label, slug) in custom_check_background" :key="slug" class="form-check form-check-inline">
            <input v-model="history.background[slug]" class="form-check-input" type="checkbox"
              :id="`customer_edit_history_background_${slug}`" autocomplete="off" />
            <label :for="`customer_edit_history_background_${slug}`" class="form-check-label">
              {{ label }}
            </label>
          </div>

          <h6 class="mt-2">Otras afecciones</h6>
          <textarea class="form-control" v-model="custom_core_background" autocomplete="off" rows="5"
            placeholder="Indique el resto de afecciones, una por línea"></textarea>
        </div>
      </div>



      <div v-if="is_core" class="form-group row">
        <div class="col customer-edit-history-section">
          <legend>¿Padece o ha padecido estas afecciones?</legend>

          <div class="form-check form-check-inline">
            <input v-model="history.habits['alcohol']" class="form-check-input" type="checkbox"
              id="customer_edit_history_habits_alcohol" autocomplete="off" />
            <label for="customer_edit_history_habits_alcohol" class="form-check-label">
              Alcohol
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.habits['tobacco']" class="form-check-input" type="checkbox"
              id="customer_edit_history_habits_tobacco" autocomplete="off" />
            <label for="customer_edit_history_habits_tobacco" class="form-check-label">
              Tabaco
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input v-model="history.habits['drugs']" class="form-check-input" type="checkbox"
              id="customer_edit_history_habits_drugs" autocomplete="off" />
            <label for="customer_edit_history_habits_drugs" class="form-check-label">
              Drogas
            </label>
          </div>

          <!-- Custom Checks -->
          <div v-for="(label, slug) in custom_check_habits" :key="slug" class="form-check form-check-inline">
            <input v-model="history.habits[slug]" class="form-check-input" type="checkbox"
              :id="`customer_edit_history_habits_${slug}`" autocomplete="off" />
            <label :for="`customer_edit_history_habits_${slug}`" class="form-check-label">
              {{ label }}
            </label>
          </div>

          <h6 class="mt-2">Otras sutancias</h6>
          <textarea class="form-control" v-model="custom_core_habits" autocomplete="off" rows="5"
            placeholder="Indique el resto de sustancias que consume, una por línea"></textarea>
        </div>
      </div>



      <div class="custom-history-section" v-for="section in clinic.custom_history_sections" :key="section.slug">
        <legend class="custom-history-section__title"
          :class="{ active: expanded_sections[section.slug] || section.required }" @click="toggleSection(section.slug)">
          {{
            section.description }}</legend>
        <template v-if="section.required || expanded_sections[section.slug]">
          <div class="row form-group" v-for="field in section.fields" :key="field.slug">
            <fill-custom-history-field :value="getCustomerHistoryValue(section, field)"
              @input="setCustomerHistoryValue(section, field, $event)" :field="field" :section="section"
              :section_data="history.custom_history[section.slug]"></fill-custom-history-field>
          </div>
        </template>
      </div>

      <div class="row form-group">
        <div class="col">
          <button type="submit" role="button" class="btn btn-primary btn-wabident-round big btn-block mt-4"
            :disabled="is_updating">
            <span class="btn-icon float-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
                <path
                  d="M14.343.3a1.027 1.027 0 0 0-.726-.3h-1.489v5.873a.41.41 0 0 1-.41.41H3.058a.408.408 0 0 1-.408-.41V0H1.024A1.023 1.023 0 0 0 0 1.024v16.95A1.025 1.025 0 0 0 1.024 19h16.95A1.028 1.028 0 0 0 19 17.974V5.381a1.025 1.025 0 0 0-.302-.724L14.343.3zm1.967 16.342a.53.53 0 0 1-.532.53H3.22a.53.53 0 0 1-.532-.53V9.557a.53.53 0 0 1 .532-.53h12.56a.53.53 0 0 1 .531.53v7.085z" />
                <path d="M11.073 0H3.705v5.227h7.368V0z" />
                <path d="M13.31 13.875H5.69a.528.528 0 1 0 0 1.056h7.62a.528.528 0 1 0 0-1.056z" />
              </svg>
            </span>

            <span v-if="is_updating">ENVIANDO ...</span>
            <span v-else>ENVIAR DATOS</span>
            <i v-if="is_updating" class="fas fa-circle-notch fa-spin float-right" style="margin-top: 5px" />
          </button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  props: ["customer", "fillkey", "clinic"],
  data() {
    return {
      show_history: false,
      is_updating: false,
      is_ok: false,
      expanded_sections: {},
      custom_core_allergies: "",
      custom_core_diseases: "",
      custom_core_medicines: "",
      custom_core_background: "",
      custom_core_habits: "",
      history: {
        allergies: {
          penicillin: false,
          latex: false,
          others: [],
          medicines: false,
          other_medicines: "",
          substances: false,
          other_substances: "",
        },
        diseases: {
          hepatitis: false,
          diabetes: false,
          heart_condition: false,
          hiv: false,
          others: [],
          hypertension: false,
          autoinmune: false,
          other_diseases: false,
          other_diseases_content: "",
        },
        medicines: {
          anticoagulants: false,
          inmunosuppressants: false,
          others: [],
          other_medicines: false,
          other_medicines_content: "",
        },
        background: {
          headache: false,
          neuralgia: false,
          bruxism: false,
          others: [],
          surgical_interventions: false,
          surgical_interventions_content: "",
          previous_treatments: false,
          previous_treatments_content: "",
        },
        habits: {
          tobacco: false,
          drugs: false,
          alcohol: false,
          others: [],
        },
        custom_history: {
        },
      },
      form: {
        name: "",
        surname: "",
        birth_date: "",
        phone: "",
        phone_alt: "",
        email: "",
        nif: "",
        address: "",
        city: "",
        zipcode: "",
        reason: "",
        reference: "",
        sex: "",
      },
    };
  },
  computed: {
    custom_check_allergies() {
      if (!this.clinic) return {};
      return this.clinic.config['custom_allergies'];
    },
    custom_check_medicines() {
      if (!this.clinic) return {};
      return this.clinic.config['custom_medicines'];
    },
    custom_check_background() {
      if (!this.clinic) return {};
      return this.clinic.config['custom_background'];
    },
    custom_check_diseases() {
      if (!this.clinic) return {};
      return this.clinic.config['custom_diseases'];
    },
    custom_check_habits() {
      if (!this.clinic) return {};
      return this.clinic.config['custom_habits'];
    },
    is_core() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_coreclinic;
    },
    customer_reasons() {
      if (!this.clinic) return {};
      return this.clinic.customer_reasons;
    },
    ...mapGetters(["errorwindow", "msgwindow"]),
  },
  methods: {
    getCustomerHistoryValue(section, field) {
      let s = this.history.custom_history[section.slug];
      if (!s || !WabiDent.isObject(s)) {
        this.$set(this.history.custom_history, section.slug, {});
      }

      let val = this.history.custom_history[section.slug][field.slug];
      switch (field.type) {
        case 'checkbox':
          if (!window.WabiDent.isObject(val)) {
            val = {};
          }
          break;
        default:
          if (typeof val === 'undefined') {
            val = null;
          }
          break;
      }

      return val;
    },
    setCustomerHistoryValue(section, field, $event) {
      let s = this.history.custom_history[section.slug];
      if (!s || !WabiDent.isObject(s)) {
        this.$set(this.history.custom_history, section.slug, {});
      }

      switch (field.type) {
        case 'checkbox':
          let v = this.getCustomerHistoryValue(section, field);
          v[$event.name] = $event.value;
          this.$set(this.history.custom_history[section.slug], field.slug, v);
          break;
        default:
          this.$set(this.history.custom_history[section.slug], field.slug, $event);
      }
    },
    toggleSection(section) {
      let val = !(this.expanded_sections[section] || false);
      this.$set(this.expanded_sections, section, val);
    },
    getLinesArray(text) {
      return text.split('\n').map((x) => {
        return x.trim();
      }).filter((x) => {
        return x && x != '';
      });
    },
    sendError(response) {
      axios
        .post(`/customer/${this.customer.id}/fill_error`, { response });
    },
    confirmSubmit() {
      if (!this.is_updating) {
        this.doSubmit();
      }
    },
    doSubmit() {
      this.is_updating = true;

      let formData = new FormData();
      for (let field in this.form) {
        let value = this.form[field];
        if (value === null || value === 'null') {
          value = '';
        }
        formData.append(field, value);
      }

      formData.append("key", this.fillkey);

      if (this.is_core) {
        this.history.allergies.others = this.getLinesArray(this.custom_core_allergies);
        this.history.diseases.others = this.getLinesArray(this.custom_core_diseases);
        this.history.habits.others = this.getLinesArray(this.custom_core_habits);
        this.history.medicines.others = this.getLinesArray(this.custom_core_medicines);
        this.history.background.others = this.getLinesArray(this.custom_core_background);
      }

      formData.append("history", JSON.stringify(this.history));

      axios
        .post(`/customer/${this.customer.id}/fill`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.msgwindow.success("Datos guardados con éxito");
          this.is_ok = true;
          if (response.data.redirect) {
            window.location = response.data.redirect;
          }
        })
        .catch((error) => {
          let msg = error.response.data ? error.response.data.message : '';
          if (!msg) {
            msg = 'Error del servidor';
          }

          this.errorwindow.show(
            "Error",
            `Error guardando datos: ${msg}.<br> Por favor consulte en Recepción`
          );

          this.sendError(response);
        })
        .then(() => {
          this.is_updating = false;
        });
    },
    checkEmpty(field) {
      if (!field && field == '') {
        return true;
      }
      return false;
    },
    validate() {
      let msgs = [];

      if (this.checkEmpty(this.form.name)) {
        msgs.push('Nombre');
      }

      if (this.is_core && this.checkEmpty(this.form.surname)) {
        msgs.push('Apellidos');
      }

      if (this.checkEmpty(this.form.birth_date)) {
        msgs.push('Fecha de nacimiento');
      }

      if (this.checkEmpty(this.form.sex)) {
        msgs.push('Sexo');
      }

      if (this.checkEmpty(this.form.phone)) {
        msgs.push('Teléfono');
      }

      if (this.checkEmpty(this.form.reason)) {
        msgs.push('¿Cómo nos conociste?');
      }

      if (msgs.length) {
        this.errorwindow.show('Error', 'Por favor rellene los siguientes campos:<br>' + msgs.join('<br>'), 'Aceptar');
        return false;
      }

      return true;
    },
    onSubmit(ev) {
      ev.preventDefault();

      if (!this.validate()) return;

      this.errorwindow.show(
        "Confirmar",
        "¿Desea enviar esta información?<p><p><strong>Por favor, no cierre la pestaña del navegador al terminar. <p> En el siguiente paso deberá revisar y aceptar nuestra Política de Protección de Datos</strong>",
        "Sí",
        "No",
        this.confirmSubmit
      );
    },
  },
  mounted() {
    this.form.sex = this.customer.sex;
    this.form.name = this.customer.name;
    this.form.surname = this.customer.surname;
    this.form.birth_date = moment.utc(this.customer.birth_date).format('YYYY-MM-DD');
    this.form.phone = this.customer.phone;
    this.form.phone_alt = this.customer.phone_alt;
    this.form.email = this.customer.email;
    this.form.nif = this.customer.nif;
    this.form.address = this.customer.address;
    this.form.city = this.customer.city;
    this.form.zipcode = this.customer.zipcode;
    this.form.reason = this.customer.reason;
    this.form.reference = this.customer.reference;

    this.history.allergies = this.customer.history.allergies;
    this.history.medicines = this.customer.history.medicines;
    this.history.diseases = this.customer.history.diseases;
    this.history.habits = this.customer.history.habits;
    this.history.background = this.customer.history.background;

    this.custom_core_allergies = this.history.allergies.others.join('\n');
    this.custom_core_medicines = this.history.medicines.others.join('\n');
    this.custom_core_diseases = this.history.diseases.others.join('\n');
    this.custom_core_habits = this.history.habits.others.join('\n');
    this.custom_core_background = this.history.background.others.join('\n');

    this.history.custom_history = this.customer.history.custom_history;

    if (!WabiDent.isObject(this.history.custom_history)) {
      this.history.custom_history = {};
    }
  },
};
</script>

<style lang="scss">
.customer-fill-data {
  .customer-edit-history-section {
    .btn-plus {
      float: right;
    }

    margin-top: 30px;

    &::after {
      margin-top: 26px;
      width: 100%;
      height: 1px;
      background-color: var(--theme-grey-disabled);
      content: "";
      display: block;
    }

    legend {
      color: var(--theme-text-color);
      font-size: 18px;
      letter-spacing: 0.36px;
      font-weight: 500;
    }

    .customer-edit-history-checks {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      margin: 23px 0 18px 0;

      .form-check+.form-check {
        margin-left: 30px;
      }
    }

    .customer-edit-history-others {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;

      margin: -5px;

      .other-entry {
        margin: 5px;
        display: flex;
        flex-direction: row nowrap;
        align-items: center;
        border: 1px var(--theme-color-absent) solid;
        border-radius: 70px;
        height: 32px;
        padding: 7px 11px;

        input {
          border: none !important;
          color: var(--theme-color-absent);
          font-size: 13px;
          line-height: 1.54;
        }

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          appearance: none;
          width: 20px;
          height: 20px;
          color: white;
          border-radius: 10px;
          background-color: var(--theme-color-absent);
          border: none;

          i {
            font-size: 12px;
          }
        }
      }
    }
  }

  .custom-history-section {
    &__title {
      text-transform: uppercase;

      &::after {
        display: inline-flex;
        color: #ffff;
        background: var(--theme-color);
        content: '+';
        vertical-align: middle;
        padding: 0 0 4.5px 0;
        font-size: 16px;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        align-items: center;
        justify-content: center;
        margin-left: 10px;
      }

      &.active::after {
        content: '−';
      }
    }
  }
}

@media (max-width: 767px) {
  .customer-fill-data .customer-edit-history-section .customer-edit-history-checks {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 23px 0 18px 0;
  }

  .customer-fill-data .customer-edit-history-section .customer-edit-history-checks .form-check+.form-check {
    margin-left: 0;
    margin-top: 15px;
  }
}
</style>
